module.exports = __webpack_public_path__ + "img/pr-8.b63337ac.png";